<template>
  <div>
    <a-row :gutter="[16,16]">
      <a-col span="6">
        <TuboDist v-model="searchParams.dist6" dict-name="dist.support" :clearable="true"
                  @on-change="search"></TuboDist>
      </a-col>
      <a-col span="6">
        <Input v-model="searchParams.fuzzy" placeholder="请输入刻章店名称" @on-enter="search"></Input>
      </a-col>
      <a-col span="12">
        <a-button type="primary" @click="search">查询</a-button>
      </a-col>

      <a-col span="12" v-for="(item, index) in dataPages" :key="index" @click.native="selectCompany(item)">
        <a-card :title="item.name">
          <a-icon slot="extra" :type="item.id !== companySelected.id ? 'border': 'check-square'" style="font-size: 18px"/>
          <div flex="dir:left" class="f-16">
            <img src="img/defaultLogo.png" width="80" height="80">
            <div class="m-l-8">
              <div>电话：{{ item.phone }}</div>
              <div>地址：{{ item.regAddress }}</div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import {api, util} from '@/libs'
import pages from '@tubo/tubo-base/mixins/mixinPages'

export default {
  name: 'OrderSelectMaker',
  mixins: [pages],
  data() {
    return {
      params: {}, // 自主买单列表的查询参数
    }
  },
  props: {},
  computed: {
    ...mapState({
      currentOrder: state => state.order.currentOrder,
      companySelected: state => state.order.companySelected ? state.order.companySelected : {},
    }),
  },
  updated() {
  },
  methods: {
    searchConditions() {
      let conditions = []

      if (this.searchParams.dist6) {
        conditions.push({op: "startswith", param: "dist6", values: util.dist6Trim(this.searchParams.dist6)})
      }

      return conditions
    },

    searchSort() {
      return ['bizSetupJsonStr,desc']
    },

    // 自主买单选择刻章企业
    selectCompany(item) {
      this.$store.commit('order/SET_COMPANY_SELECTED', item)
    },
  },

  created() {
    this.searchParams.fuzzyParams = ['name']
    this.searchApi = api.libClient.companyScope

    // if (this.currentOrder.dist6) {
    //   this.searchParams.params = {dist6: this.currentOrder.dist6}
    // } else
    if (this.currentOrder.uscc) {
      this.searchParams.params = {dist6: this.currentOrder.uscc.substr(2, 6)}
    } else if (this.currentOrder.samr && this.currentOrder.samr.aicDist6) {
      this.searchParams.params = {dist6: this.currentOrder.samr.aicDist6.substr(0, 6)}
    } else {
      this.searchParams.params = {dist6: "000000"}
    }

    this.searchParams.dist6 = this.searchParams.params.dist6
  }
}
</script>